module.exports = __webpack_public_path__ + "img/4-r.bd156805.png";